module.exports = __webpack_public_path__ + "static/media/delete-button-chart-form.76c499b3.svg";